<button (click)="selectAll()" class="full-width" color="primary" mat-button>{{ 'CONTROLS.select_all' | translate }}</button>
